import React, { Component } from "react";

import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { Row } from "reactstrap";
import { bindActionCreators } from "redux";

import { logout } from "../../../../actions/baseActions";
import { setObj } from "../../../../actions/noteActions";
import Breadcrumb from "../../../../components/Breadcrumb";
import Loading from "../../../../components/Loading";
import ProtectedRoute from "../../../../components/ProtectedRoute";
import DataTable from "../../../../components/Tables/tables";
import URL from "../../../../config/api";
import axios from "../../../../config/axios";

class RoleList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // components: [],
      loading: true
    };

    this.error = this.error.bind(this);
    this.insertRole = this.insertRole.bind(this);
    // this.deleteRole = this.deleteRole.bind(this);
  }

  error(response) {
    if (response === "Unauthorized") {
      this.props.logout(this.props.user.token);
    } else {
      toastr.error("Fail", response);
    }
  }

  insertRole() {
    this.props.history.push("/role/form");
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillMount() {
    this.props.setObj(16, this.props.currentRoute, this.props.currentRoute);
    axios
      .get(`${URL.api}access/role/list`, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(resp => {
        this.setState(
          () => ({
            list: resp.data.data
          }),
          () => {
            this.setState(() => ({
              loading: false
            }));
          },
          error => {
            this.error(error.response.statusText);
          }
        );
      });
  }

  /* deleteRole = (data) => {
        this.setState(() => {
            return {
                loading: true,
            };
        },()=>{
            data.forEach(elem => {
                let dataSend = {
                    id: elem,
                    loggedUser: this.props.user.user.id
                }
                axios.post(URL.api+'role/delete', dataSend,{headers: {'authorization': 'Bearer '+ this.props.user.token}})
                .then(
                    resp => {
                            this.// eslint-disable-next-line camelcase
  UNSAFE_componentWillMount();
                    }
                )
            });
        })
    } */

  render() {
    return (
      <div className="animated fadeIn">
        {this.state.loading ? (
          <Loading top="45" left="50" />
        ) : (
          <Row>
            <Breadcrumb current={this.props.currentRoute} />
            {this.state.list ? (
              <div id="list">
                <DataTable
                  list={this.state.list}
                  path="/role/edit/"
                  title="Perfis"
                  header={[
                    { name: "id", denomination: "ID" },
                    { name: "name", denomination: "Nome" },
                    { name: "type", denomination: "Tipo" }
                  ]}
                  insert
                  delete
                  insertAction={this.insertRole}
                />
              </div>
            ) : (
              <Loading />
            )}
          </Row>
        )}
        <ProtectedRoute routeId={this.props.currentRoute} />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(RoleList);
